import React from 'react';
import './styles/leadDetails.css';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
// import MenuItem from '@material-ui/core/MenuItem';
import { ReactComponent as DownloadWhite } from '../../../assets/DownloadWhite.svg';
import useStyles from './styles/leadDetails';

const HotTag = () => {
  const classes = useStyles();
  return (
    <span className={classes.hotTagContainer}>
      <span className={classes.hotTagText}>HOT</span>
    </span>
  );
};

function ConfirmAdmissionScreen(props) {
  const [saveStatus, setSaveStatus] = React.useState('');

  const handleSaveStatus = (event) => {
    setSaveStatus(event.target.value);
  };

  // Docs Pop-up
  const classes = useStyles();
  const downloadSelectedCSV = () => {
    props.dispatchDownloadSelectedCSV([localStorage.getItem('leadId')]);
  };

  // const capitalize = (s) => {
  //   if (typeof s !== 'string') return '';
  //   return s.charAt(0).toUpperCase() + s.slice(1);
  // };

  return (
    <div className={classes.CreateLeadmain}>
      <div className={classes.createleadchiled}>
        <div className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <div className={classes.createlead}>
                <div className={classes.titlefont}>School details</div>
              </div>
              <div className={classes.contect}>
                <p>Manage lead status, schedule a appointment.</p>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div style={{ float: 'right' }}>
                <Button
                  component={Link}
                  to={'/lead-management/edit-lead'}
                  disableElevation
                  className={classes.cancel}
                  variant="contained"
                  style={{ textTransform: 'none' }}
                  size="large">
                  Edit
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  disableElevation
                  style={{ textTransform: 'none' }}
                  className={classes.saveDownload}
                  onClick={downloadSelectedCSV}>
                  <DownloadWhite style={{ marginRight: '8px' }} />
                  Download CSV
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
        <div>
          <div className={classes.seconudcontainer}>
            <Grid container spacing={3}>
              <Grid item xs={8}>
                <div className={classes.leadborder}>
                  {/* <div className={classes.profile}>
                    <div className={classes.profileInitials}>
                      {lead.name.match(/\b\w/g).join('')}
                    </div>
                  </div> */}
                  <Grid container className={classes.containerMargin}>
                    <Grid item xs={2} style={{ paddingRight: '16px' }}>
                      {/* <ReactRoundedImage
                          image={
                            typeof leadImage !== 'string'
                              ? URL.createObjectURL(leadImage)
                              : DefaultLogo
                          }
                          roundedSize="0"
                          imageWidth="122"
                          imageHeight="122"
                        /> */}
                      image
                    </Grid>
                    <Grid item xs={10} style={{ paddingLeft: '16px' }}>
                      <Grid
                        style={{ paddingBottom: '8px', paddingTop: '5px' }}
                        className={classes.profilename}
                        item>
                        New English School
                        <HotTag />
                      </Grid>
                      <Grid style={{ paddingBottom: '24px' }} item>
                        <span className={classes.profileID}>ID #3456 •</span>
                        <span className={classes.profileCreatedOn}>
                          &nbsp;Created on: 1234
                        </span>
                      </Grid>
                      <Grid item>
                        <form noValidate autoComplete="off">
                          <FormControl
                            variant="outlined"
                            className={classes.formControl + ' backColour'}>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              value={saveStatus}
                              style={{
                                color:
                                  saveStatus === 'converted'
                                    ? 'green'
                                    : saveStatus === 'inactive'
                                    ? 'grey'
                                    : '#FE4500',
                              }}
                              onChange={handleSaveStatus}
                              className={classes.dropdownText}>
                              {/* {leadStatusDropdown.map((status, idx) => {
                                return (
                                  <MenuItem
                                    key={idx}
                                    value={status}
                                    // onClick={() =>
                                    //   handleSaveStatusToggle(status)
                                    // }
                                  >
                                    {capitalize(status)}
                                  </MenuItem>
                                );
                              })} */}
                            </Select>
                          </FormControl>
                        </form>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    style={{ borderBottom: '1px solid #dfdfdf' }}
                    spacing={3}
                    container
                    className={classes.containerMargin}>
                    <Grid
                      item
                      xs={5}
                      container
                      className={classes.platformContainer}>
                      <Grid item xs={6}>
                        {/* {lead.platformLead && lead.platformLead === true
                          ? 'Platform Lead'
                          : 'Non Platform Lead'} */}
                        Platform
                      </Grid>
                      <Grid
                        className={classes.shareLinkText}
                        item
                        xs={6}
                        container
                        justify="flex-end">
                        Share Link now
                      </Grid>
                    </Grid>
                    <Grid item xs={1} />
                    <Grid
                      item
                      xs={6}
                      container
                      className={classes.platformContainer}>
                      <Grid item xs={6}>
                        Messaging history
                      </Grid>
                      <Grid
                        className={classes.shareLinkText}
                        item
                        xs={6}
                        container
                        justify="flex-end">
                        View chats
                      </Grid>
                    </Grid>
                  </Grid>

                  <div>
                    <div className={classes.details}>
                      <div
                        className={classes.fontleadbold}
                        style={{ marginBottom: '0.5rem' }}>
                        Lead details
                      </div>
                      <div className={classes.leaddetails}>
                        <Grid container spacing={3}>
                          <Grid item xs={4}>
                            <div className={classes.fontlead}>Assigned to</div>
                          </Grid>
                          <Grid item xs={8}>
                            <div className={classes.fontanswer}>
                              {/* {capitalize(lead.assignedToName)} */}
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.leaddetails}>
                        <Grid container spacing={3}>
                          <Grid item xs={4}>
                            <div className={classes.fontlead}>For Branch</div>
                          </Grid>
                          <Grid item xs={8}>
                            <div className={classes.fontanswer}>
                              {/* {capitalize(lead.branch)} */}RG International
                              School of Art
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.leaddetails}>
                        <Grid container spacing={3}>
                          <Grid item xs={4}>
                            <div className={classes.fontlead}>Contact No.</div>
                          </Grid>
                          <Grid item xs={8}>
                            <div className={classes.fontanswer}>
                              {/* {lead.phone} */}1234567890
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.leaddetails}>
                        <Grid container spacing={3}>
                          <Grid item xs={4}>
                            <div className={classes.fontlead}>E-mail ID</div>
                          </Grid>
                          <Grid item xs={8}>
                            <div>{/* {lead.email} */}example@gmail.com</div>
                          </Grid>
                        </Grid>
                      </div>
                      <div
                        className={classes.fontleadbold}
                        style={{ marginBottom: '0.5rem' }}>
                        Student details
                      </div>
                      {/* {lead.children.map((child, i) => {
                        return (
                          <> */}
                      <div style={{ marginBottom: '0.8rem' }}>
                        Student
                        {/* {i + 1} */}1
                      </div>
                      <div>
                        <Grid container spacing={3}>
                          <Grid item xs={4}>
                            <div>Name</div>
                          </Grid>
                          <Grid item xs={8}>
                            <div>
                              {/* {child.name ? child.name : '-'} */}
                              Onkar
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.leaddetails}>
                        <Grid container spacing={3}>
                          <Grid item xs={4}>
                            <div className={classes.fontlead}>
                              Date of Birth
                            </div>
                          </Grid>
                          <Grid item xs={8}>
                            <div className={classes.fontanswer}>
                              {/* {child.dob
                                      ? child.dob.substring(0, 10)
                                      : '-'} */}
                              01/01/2015
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.leaddetails}>
                        <Grid container spacing={3}>
                          <Grid item xs={4}>
                            <div className={classes.fontlead}>Gender</div>
                          </Grid>
                          <Grid item xs={8}>
                            <div className={classes.fontanswer}>
                              {/* {child.gender
                                      ? capitalize(child.gender)
                                      : '-'} */}
                              male
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                      <div className={classes.leaddetails}>
                        <Grid container spacing={3}>
                          <Grid item xs={4}>
                            <div className={classes.fontlead}>Class</div>
                          </Grid>
                          <Grid item xs={8}>
                            <div className={classes.fontanswer}>
                              {/* {child.grade} */}1
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                      {/* </>
                        );
                      })} */}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmAdmissionScreen;
